__turbopack_context__.v({
  "className": "VZc0YW_className",
});
